// Takes a list of strings, and joins them with commas, with the
// last string joined with "and".
// e.g. ["one, "two", "three"] => 'one, two and three'
export const concatenateUserGroups = (groups) => {
  if (!groups || groups.length === 0) {
    return '';
  }

  if (groups.length === 1) {
    return groups[0];
  }

  const allButLast = groups.slice(0, -1).join(', ');
  const last = groups[groups.length - 1];
  return `${allButLast} and ${last}`;
};
